import React, { Component } from 'react';
import './index.less';

/**
 * 页脚
 */
class Footer extends Component {
    render(){
        return (
            <div className="footer">Copyright &copy; 五八同城信息技术有限公司 版权所有</div>
        );
    }
}

export default Footer; 


// WEBPACK FOOTER //
// ./_source/cqsx/pages/cqsx/cmps/footer/index.js